import { APIData } from "./constants/APIAdresses";

// export class APIHelper {


// resolves with {role: }
export function checkSession() {
    return new Promise((resolve, reject) => {
        let uri = APIData.USER + "/auth/session/checkCreate";
        var bodyParamsObj = {}
        fetch(uri, { body: JSON.stringify(bodyParamsObj), method: "POST", credentials: "include", headers: { 'Content-Type': 'application/json' } })
            .then(response => {
                if (response.status === 200) {
                    return response.json();
                } else {
                    return null;
                }
            })
            .then(result => {
                if (result != null) {
                    resolve(result);
                } else {
                    reject();
                }
            }).catch(e => {
                reject();
                console.log("Error while checkSession...: ", e);
            })
    })
}
export function getSupportMessages(scid, offset) {
    return new Promise((resolve, reject) => {
        let uri = APIData.REALTIME + "/support/getMessages?bigDisplay=1&isInverted=1&scid=" + scid + "&offsetMultiplier=" + offset;
        fetch(uri, { credentials: "include" })
            .then(response => {
                console.log("ResponseStatus: ", response.status);
                if (response.status === 200) {
                    return response.json();
                } else {
                    console.log("ErrStatus while loading supportMessages: ", response.status);
                }
            }).then(result => {
                if (result != null) {
                    resolve(result);
                } else {
                    reject();
                }
            }).catch(e => {
                console.log("Error while getSupportMessages: ", e);
                reject();
            })
    })
}

/**
 * 
 * @param {*} file file to upload
 * @param {*} uploadType upload type, e.g. 'products', 'support', 'users'
 * @param {*} relSelectionUrl if it was a selection from the media manager, this is the relative URL to the image
 * @returns 
 */
export function uploadImage(file, uploadType, relSelectionUrl) {
    return new Promise((resolve, reject) => {
        if (relSelectionUrl != null) {
            resolve(relSelectionUrl);
        } else if (file == null) {
            resolve(null)
        } else {
            let formData = new FormData();
            formData.append("image", file);
            fetch(APIData.MEDIA + "/upload?type=" + uploadType, { body: formData, method: "POST", credentials: "include" })
                .then(response => {
                    if (response.ok) {
                        return response.json();
                    } else {
                        reject("Error while uploading image");
                    }
                }).then(result => {
                    console.log("UPLOADRESULT: ", result);
                    if (result?.path) {
                        resolve(result.path);
                    } else {
                        reject("Error while uploading image");
                    }
                }).catch(e => {
                    reject("Error while uploading image: " + e);
                })
        }
    })
}

/**
 * endpoint must be a function that takes page, ipp, search (in the right order!) and returns an URL string. 
 * TODO: We might change that in the future.
 * @param {*} param0 
 * @returns 
 */
export async function getPaginated({ endpoint, page, ipp, search, body, method }) {
    const p = Number.parseInt(page, 10);
    const i = Number.parseInt(ipp, 10);
    // build URL safely
    // const urlObj = new URL(endpoint, this.apiBaseUrl || undefined); // apiBaseUrl optional
    // urlObj.searchParams.set("page", String(Number.isNaN(p) ? 0 : p));
    // urlObj.searchParams.set("ipp", String(Number.isNaN(i) ? 20 : i));
    // if (search != null && search.length >= 3) {
    //     urlObj.searchParams.set("search", search);
    // }
    console.log("ENDPOIINT!!:_ ", endpoint, " with page: ", p, " ipp: ", i, " search: ", search);
    const urlObj = endpoint(Number.isNaN(p) ? 0 : p, Number.isNaN(i) ? 20 : i, search);
    console.log("Getting paginated data from ", urlObj.toString(), " with page: ", p, " ipp: ", i, " search: ", search, " body: ", body, " method: ", method);

    const options = {
        method: method || (body ? "POST" : "GET"),
        headers: {
            "Content-Type": "application/json",
            // Cookie: this.apiCookie, // try Cookie casing
        },
        credentials: "include",
    };
    console.log("Fetch options for paginated request: ", options);
    if (body != null) options.body = JSON.stringify(body);

    const response = await fetch(urlObj.toString(), options);
    console.log("Fetching paginated data from ", urlObj.toString(), " with options: ", options, " and body: ", body, " got response with status: ", response.status);
    // try to parse json either way (many APIs return json on errors too)
    let payload = null;
    const ct = response.headers.get("content-type") || "";
    if (ct.includes("application/json")) {
        payload = await response.json();
    } else {
        // avoid throwing away useful text errors
        payload = await response.text().catch(() => null);
    }

    if (!response.ok) {
        console.log(`Error while fetching paginated data from ${urlObj.toString()}:`, response.status, payload);
        throw new Error(`Server responded with status ${response.status}`);
    }
    console.log("Successfully fetched paginated data from ", urlObj.toString(), " with payload: ", payload);
    return payload;
}


/**
    * companyId not required for merchants, since it is being set automatically from the session at the backend.
    * @param {*} param0 
    * @returns result is an array of { id: insertedId, code, pin, expiresAt (optional) } to display in our UI right after generation
    */
export async function generateBulkGiftcards({ expirationDate, amount, shopIdList, companyId, quantity }) {
    try {
        let body = { expirationDate, amount, shopIdList, companyId, quantity };
        console.log("Generating bulk giftcards with body: ", body);
        // let url = this.Links.generateBulkGiftcards;
        let url = APIData.USER + "/giftcard/generateBulkGiftCards"; // TODO: move to APIData
        console.log("Constructed URL for generateBulkGiftcards: ", url);
        const response = await fetch(url, { method: "POST", credentials: "include", headers: { "Content-Type": "application/json" }, body: JSON.stringify(body) });
        if (response.ok) {
            // result is an array of { id: insertedId, code, pin } to display in our UI right after generation
            return await response.json();
        } else {
            console.log("ErrStatus while generateBulkGiftcards: ", response.status);
            return null;
        }
    } catch (e) {
        console.error("Error while generateBulkGiftcards: ", e);
        return null;
    }
}

export async function getShopInfoByIdList(shopIds, companyId) {
    try {
        let url = `${APIData.SHOP}/shop/getByIdList?${companyId != null ? `companyId=${companyId}` : shopIds.map(id => `id=${id}`).join("&")}`;
        const response = await fetch(url, { credentials: "include", headers: {} });
        if (response.ok) {
            return await response.json();
        } else {
            console.log("ErrStatus while getShopInfoByIdList:", response.status);
            return null;
        }
    } catch (e) {
        console.log("Error while getShopInfoByIdList:", e);
        return null;
    }
}

export async function createPromoCode(promoCodeData) {
    try {
        let url = `${APIData.SHOP}/promocode/create`;
        console.log("Creating promo code with URL: ", url, " and data: ", promoCodeData);
        const response = await fetch(url, { credentials: "include", method: "POST", body: JSON.stringify(promoCodeData), headers: { "Content-Type": "application/json" } });
        if (response.ok) {
            const jsonResult = await response.json();
            console.log("Promo code created successfully: ", jsonResult);
            return jsonResult;
        } else {
            console.log("Failed to create promo code. Status: ", response.status);
            return null;
        }
    } catch (error) {
        console.error("Error while createPromoCode: ", error);
        return null;
    }
}

export async function editPromoCode(promoCodeData) {
    try {
        let url = `${APIData.SHOP}/promocode/edit`;
        console.log("Editing promo code with URL: ", url, " and data: ", promoCodeData);
        const response = await fetch(url, { credentials: "include", method: "PUT", body: JSON.stringify(promoCodeData), headers: { "Content-Type": "application/json" } });
        if (response.ok) {
            const jsonResult = await response.json();
            console.log("Promo code edited successfully: ", jsonResult);
            return jsonResult;
        } else {
            console.log("Failed to edit promo code. Status: ", response.status);
            return null;
        }
    } catch (error) {
        console.error("Error while editPromoCode: ", error);
        return null;
    }
}

export async function getPromoCodeById(promoId) {
    try {
        const response = await fetch(`${APIData.SHOP}/promocode/get/${parseInt(promoId)}`, { credentials: "include" });
        if (response.ok) {
            const jsonResult = await response.json();
            console.log("Promo code data fetched successfully: ", jsonResult);
            return jsonResult;
        } else {
            console.log("Failed to fetch promo code data. Status: ", response.status);
            return null;
        }
    } catch (error) {
        console.error("Error while getPromoCodeById: ", error);
        return null;
    }
}

export async function getCategoriesByIdList(idList) {
    try {
        let url = `${APIData.SHOP}/categories/getByIdList?${idList.map(id => `idList=${id}`).join("&")}`;
        const response = await fetch(url, { credentials: "include" });
        if (response.ok) {
            const result = await response.json();
            return result;
        } else {
            console.log("ErrStatus while getCategoriesByIdList: ", response.status);
            return null;
        }
    } catch (e) {
        console.log("Error while getCategoriesByIdList: ", e);
        return null;
    }
}

export async function getProductsByIdList(idList) {
    try {
        let url = `${APIData.SHOP}/products/getByIdList?${idList.map(id => `idList=${id}`).join("&")}`;
        const response = await fetch(url, { credentials: "include" });
        if (response.ok) {
            const result = await response.json();
            return result;
        } else {
            console.log("ErrStatus while getProductsByIdList: ", response.status);
            return null;
        }
    } catch (e) {
        console.log("Error while getProductsByIdList: ", e);
        return null;
    }
}

export async function getPromoByIdList(idList) {
    try {
        let url = `${APIData.SHOP}/promocode/getByIdList?${idList.map(id => `idList=${id}`).join("&")}`;
        const response = await fetch(url, { credentials: "include" });
        if (response.ok) {
            const result = await response.json();
            return result;
        } else {
            console.log("ErrStatus while getPromoByIdList: ", response.status);
            return null;
        }
    } catch (e) {
        console.log("Error while getPromoByIdList: ", e);
        return null;
    }
}

export async function checkCodeAvailabilityForCreation({ shopIds, companyId, code }) {
    const body = {
        shopIds, companyId, code
    }
    try {
        let url = `${APIData.SHOP}/promocode/checkCodeAvailability`;
        const response = await fetch(url, { credentials: "include", method: "POST", body: JSON.stringify(body), headers: { "Content-Type": "application/json" } });
        return response.ok;
    } catch (error) {
        console.error("Error while checkCodeAvailabilityForCreation: ", error);
        return false;
    }
}

export async function setPromoCodeActiveStatus(promoId, active) {
    const isActive = active ? 1 : 0;
    try {
        let url = `${APIData.SHOP}/promocode/${promoId}/status/${isActive}`;
        const response = await fetch(url, { credentials: "include", method: "PATCH", body: JSON.stringify({ promoId, isActive }), headers: { "Content-Type": "application/json" } });
        // return response.ok;
        if (response.ok) {
            console.log(`Promo code with ID ${promoId} is now ${active ? "active" : "inactive"}.`);
            return { result: "success" };
        } else {
            console.log(`Failed to set promo code active status. Status: ${response.status}`);
            return null;
        }
    } catch (error) {
        console.error("Error while setPromoCodeActiveStatus: ", error);
        return null;
    }
}
export async function getGiftCardLedgerEntries({ page, ipp, search, giftCardId, userId, sessionId, eventType }) {
    console.log("Getting gift card ledger entries with params: ", { page, ipp, search, giftCardId, userId, sessionId, eventType });
    // let url = this.Links.getGiftCardLedgerEntries(page, ipp, search, giftCardId, userId, sessionId, eventType)
    let url = `${APIData.USER}/giftcard/giftCardLedger?page=${parseInt(page)}&ipp=${parseInt(ipp)}${search != null && search.length >= 3 ? `&search=${encodeURIComponent(search)}` : ""}${giftCardId != null ? `&giftCardId=${parseInt(giftCardId)}` : ""}${userId != null ? `&userId=${parseInt(userId)}` : ""}${sessionId != null ? `&sessionId=${encodeURIComponent(sessionId)}` : ""}${eventType != null ? `&eventType=${encodeURIComponent(eventType)}` : ""}`
    try {
        console.log("Fetching gift card ledger entries from URL: ", url);
        const response = await fetch(url, { credentials: "include" });
        if (response.ok) {
            const jsonResult = await response.json();
            console.log("Gift card ledger entries fetched successfully: ", jsonResult);
            return jsonResult;
        } else {
            console.log("Failed to fetch gift card ledger entries. Status: ", response.status);
            return null;
        }
    } catch (error) {
        console.error("Error while getGiftCardLedgerEntries: ", error);
        return null;
    }
}

export async function getPromoCodeLedgerEntries({ page, ipp, search, promoId }) {
    let url = `${APIData.USER}/promocode/redemptions?page=${parseInt(page)}&ipp=${parseInt(ipp)}${search != null && search.length >= 3 ? `&search=${encodeURIComponent(search)}` : ""}${promoId != null ? `&promoId=${parseInt(promoId)}` : ""}`;
    console.log("Fetching promo code ledger entries from URL: ", url);
    try {
        const response = await fetch(url, { credentials: "include" });
        if (response.ok) {
            const jsonResult = await response.json();
            console.log("Promo code ledger entries fetched successfully: ", jsonResult);
            return jsonResult;
        } else {
            console.log("Failed to fetch promo code ledger entries. Status: ", response.status);
            return null;
        }
    } catch (error) {
        console.error("Error while getPromoCodeLedgerEntries: ", error);
        return null;
    }
}

export async function sharePromoCodes(shopId, promoCodeList) {
    try {
        // 
        let url = `${APIData.SHOP}/promocode/shop/${shopId}/share`;
        let body = { promoCodes: promoCodeList };
        console.log("Sharing promo codes with URL: ", url, " and body: ", body);
        const response = await fetch(url, { credentials: "include", method: "POST", body: JSON.stringify(body), headers: { "Content-Type": "application/json" } });
        if (!response.ok) {
            console.log("Failed to share promo codes. Status: ", response.status);
            return null;
        }
        return { success: true };
    } catch (error) {
        console.error("Error while sharePromoCodes: ", error);
        return null;
    }
}